import { createSelector } from 'reselect';

const selectBlogRequests = (state: any) => state.blogRequests;


export const selectBlogRequestsCurrentItem = createSelector([selectBlogRequests], (blogRequests) => blogRequests.current);

export const selectBlogRequestsListItems = createSelector([selectBlogRequests], (blogRequests) => blogRequests.list);

export const selectBlogRequestsItemById = (itemId: any) =>
    createSelector(selectBlogRequestsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBlogRequestsQueryItems = createSelector([selectBlogRequests], (blogRequests) => blogRequests.query);
export const selectBlogRequestsCreatedItem = createSelector([selectBlogRequests], (blogRequests) => blogRequests.create);

export const selectBlogRequestsUpdatedItem = createSelector([selectBlogRequests], (blogRequests) => blogRequests.update);

export const selectBlogRequestsReadItem = createSelector([selectBlogRequests], (blogRequests) => blogRequests.read);

export const selectBlogRequestsDeletedItem = createSelector([selectBlogRequests], (blogRequests) => blogRequests.delete);

export const selectBlogRequestsSearchedItems = createSelector([selectBlogRequests], (blogRequests) => blogRequests.search);

export const selectBlogRequestsItemsCount = createSelector([selectBlogRequests], (blogRequests) => blogRequests.count);

export const selectBlogRequestsItemsFilter = createSelector([selectBlogRequests], (blogRequests) => blogRequests.filter);